import React from 'react';
import './featureContent.css';

/**
 * Generic section wrapper with optional centered header (title + description).
 * @param {boolean} alt - use alternate background tint
 * @param {string} className - extra class(es) applied to the section element
 * @param {string} id - optional id applied to the section element (scroll target)
 */
function FeatureSection({ alt = false, title, description, children, className = '', id }) {
    return (
        <section id={id} className={`fc-section${alt ? ' fc-section-alt' : ''}${className ? ` ${className}` : ''} sp-90`}>
            <div className="container">
                {(title || description) && (
                    <div className="fc-section-header">
                        {title && <h2 className="h-1 h-bold fc-section-title">{title}</h2>}
                        {description && <p className="fc-section-description">{description}</p>}
                    </div>
                )}
                {children}
            </div>
        </section>
    );
}

export default FeatureSection;
